import { KitDeletionArea } from "@/components/KitDeletionArea";
import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { AppTopRightMenu } from "@/components/app-layout/AppTopRightMenu";
import { ArtifactMetadata } from "@/components/display/attributes/ArtifactMetadata";
import DisplayEditor from "@/components/display/display-editor/DisplayEditor";
import { GrantDialog } from "@/components/grant/GrantDialog";
import { useKitData } from "@/data/use-kits-data";
import {
  useKitTemplateData,
  useKitTemplatesData,
} from "@/data/use-templates-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useKitUuid } from "@/hooks/use-kit-uuid";

export default function TemplateSettingsPage() {
  const groupUuid = useGroupUuid();
  const kitUuid = useKitUuid();
  const { kit, updateKit } = useKitData(groupUuid, kitUuid);
  const { templates } = useKitTemplatesData(groupUuid, kitUuid);
  const templateUuid = templates[0]?.uuid;
  const { updateTemplate, template } = useKitTemplateData(
    groupUuid,
    kitUuid,
    templateUuid,
  );

  if (!template || !groupUuid) {
    return null;
  }

  return (
    <>
      <AppTopRightMenu.ContentPortal display="append">
        <GrantDialog
          groupUuid={groupUuid}
          objectName={template.name}
          templateUuid={template.uuid}
        />
      </AppTopRightMenu.ContentPortal>
      <Page>
        <PageHeader>
          <PageHeader.Title>Template Settings</PageHeader.Title>
        </PageHeader>
        <PageBody>
          <PageBody.Metadata className="justify-end">
            <PageBody.MetadataGroup>
              <ArtifactMetadata artifact={template} />
            </PageBody.MetadataGroup>
          </PageBody.Metadata>
          <DisplayEditor
            name={template.name}
            description={template.description as string}
            onNameChange={async (name) => {
              await updateTemplate({ name });
              await updateKit({ name });
            }}
            onDescriptionChange={async (description) => {
              await updateTemplate({ description });
              await updateKit({ description });
            }}
          />
          {kit && <KitDeletionArea kit={kit} />}
        </PageBody>
      </Page>
    </>
  );
}
